/**
 * liveDataSlice — hot-path live market data.
 *
 * Updated on every polling tick (2s spot / 60s chain). Holds the live option
 * chain, spot LTP, display meta, and worker-pre-calculated metrics, keyed by
 * symbol. Kept separate from history so a tick never invalidates history
 * subscribers' selectors.
 */
import type { StateCreator } from 'zustand'
import type { MarketStore, LiveDataState, MarketData, OptionChainRow } from './types'

export const createLiveDataSlice: StateCreator<MarketStore, [], [], LiveDataState> = (set) => ({
    data: {},
    fullData: {},
    indexLtp: {},
    marketMeta: {},
    marketMetrics: {},
    lastUpdated: 0,

    updateTick: (symbol, ltp, chain, meta, metrics) => {
        // STATE LAYER: Dumb store only.
        // Normalization (diffing) and batching are handled upstream
        // (GlobalMarketEngine & MarketDataBus)
        return set((state) => ({
            indexLtp: { ...state.indexLtp, [symbol]: ltp },
            data: { ...state.data, [symbol]: chain },
            marketMeta: meta ? { ...state.marketMeta, [symbol]: meta } : state.marketMeta,
            marketMetrics: metrics ? { ...state.marketMetrics, [symbol]: metrics } : state.marketMetrics,
            lastUpdated: Date.now(),
        }))
    },

    updateData: (symbol, newData) => {
        return set((state) => ({
            fullData: { ...state.fullData, [symbol]: newData },
            lastUpdated: Date.now(),
        }))
    },

    updateTimestamp: () => set({ lastUpdated: Date.now() }),
})
